var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBugsnag = function SvgLogoBugsnag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 77.333,
    viewBox: "0 0 78 58"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bugsnag")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3776A0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.3 14.8-4.2 4.9 3 2.9c4.3 4.1 8.9 14.1 9.6 20.7l.6 5.7h6.3c7.3 0 7 .4 5.4-9.4-1.3-7.9-6.6-18.9-12.1-25l-4.4-4.8-4.2 5zM51 12.6c-1.9 1.4-4.1 2.9-4.8 3.3-1.1.6-.7 1.9 1.8 5.7 3.9 6.2 7 16.1 7 22.5V49h13v-3.5c0-6.6-3.4-18.8-7.4-26.8-2.3-4.5-4.6-8.2-5.1-8.4-.6-.2-2.6.8-4.5 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 22.8-2.5 5.7 2.6 1.6C18.5 33.6 23 40.9 23 46.5c0 2.4.2 2.5 6.6 2.5h6.5l-.6-4.7C34 34.1 27.4 23.8 19.2 19.2l-4-2.2-2.4 5.8z"
  }))));
};
export default SvgLogoBugsnag;